import { render, staticRenderFns } from "./slideTab.vue?vue&type=template&id=25380762"
import script from "./slideTab.vue?vue&type=script&lang=js"
export * from "./slideTab.vue?vue&type=script&lang=js"
import style0 from "./slideTab.vue?vue&type=style&index=0&id=25380762&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports